(() => {
 const root=document.documentElement;
 const form=document.getElementById('GccInterestForm');
 const toggle=document.querySelector('[data-language-toggle]');
 if(!form||!toggle)return;
 const panel=document.querySelector('[data-preorder-panel]');
 const choices=Array.from(form.querySelectorAll('[data-order-intent]'));
 const packInput=document.getElementById('GccPack');
 const quantityInput=document.getElementById('GccQuantity');
 const countryInput=document.getElementById('GccCountry');
 const consent=form.querySelector('[data-interest-consent]');
 const submit=form.querySelector('[data-register-submit]');
 const email=document.getElementById('GccEmail');
 const countries={'Bahrain':'BH','Kuwait':'KW','Oman':'OM','Qatar':'QA','Saudi Arabia':'SA','United Arab Emirates':'AE'};
 const packs={
  '67804161343767':{cans:12,ar:'كرتون من ١٢ عبوة',en:'12-can case'},
  '67804161376535':{cans:1920,ar:'طبليّة من ١٩٢٠ عبوة',en:'1,920-can pallet'},
  '67804161409303':{cans:9600,ar:'٥ طبالي من ٩٦٠٠ عبوة',en:'5-pallet pack (9,600 cans)'}
 };
 let currency='CAD';
 let marketCountry='';
 let availableCountries=[];
 try {
  const catalog=JSON.parse(document.querySelector('[data-gcc-catalog]').textContent);
  currency=catalog.currency||'CAD';
  marketCountry=catalog.country||'';
  availableCountries=catalog.countries||[];
  Object.keys(packs).forEach(id=>{
   const v=catalog.variants.find(v=>String(v.id)===id);
   if(v&&Number.isSafeInteger(Number(v.price))&&Number(v.price)>0)packs[id].price=Number(v.price);
   else delete packs[id];
  });
 } catch(_){Object.keys(packs).forEach(id=>delete packs[id]);}
 function intent(){return choices.find(el=>el.checked)?.dataset.orderIntent||'interest';}
 function selected(){return {variant:packInput?.value,quantity:Number(quantityInput?.value)};}
 function valid(value){return value&&packs[value.variant]&&Number.isInteger(value.quantity)&&value.quantity>=1&&value.quantity<=999;}
 function money(cents){return new Intl.NumberFormat(root.lang==='ar'?'ar-SA':'en-CA',{style:'currency',currency}).format(cents/100);}
 function refreshSummary(){
  if(!panel)return;
  const value=selected();
  const checkout=panel.querySelector('[data-checkout-button]');
  const enabled=panel.dataset.enabled==='true'&&/^[A-Z0-9]{3,32}$/.test(panel.dataset.discount||'');
  checkout.disabled=!enabled||!valid(value);
  if(!valid(value)){
   panel.querySelectorAll('[data-subtotal],[data-savings],[data-total],[data-selection-summary]').forEach(el=>el.textContent='—');
   return;
  }
  const pack=packs[value.variant];
  const subtotal=pack.price*value.quantity;
  const savings=Math.floor(pack.price*.25)*value.quantity;
  panel.querySelector('[data-selection-summary]').textContent=new Intl.NumberFormat(root.lang==='ar'?'ar-SA':'en').format(value.quantity)+' × '+pack[root.lang]+' · '+new Intl.NumberFormat(root.lang==='ar'?'ar-SA':'en').format(value.quantity*pack.cans)+' '+(root.lang==='ar'?'عبوة':'cans');
  panel.querySelector('[data-subtotal]').textContent=money(subtotal);
  panel.querySelector('[data-savings]').textContent='− '+money(savings);
  panel.querySelector('[data-total]').textContent=money(subtotal-savings);
  panel.querySelector('[data-code]').textContent=panel.dataset.discount+(enabled?'':(root.lang==='ar'?' · غير مفعّل':' · inactive'));
 }
 function refreshChoice(){
  const isPreorder=intent()==='preorder';
  form.querySelectorAll('[data-choice-hint]').forEach(el=>el.hidden=el.dataset.choiceHint!==intent());
  if(panel)panel.hidden=!isPreorder;
  if(submit)submit.hidden=isPreorder;
  if(consent){consent.hidden=isPreorder;consent.querySelector('input').disabled=isPreorder;}
  form.querySelectorAll('[data-interest-reassurance]').forEach(el=>el.hidden=isPreorder);
  if(email){email.required=!isPreorder;email.disabled=isPreorder;email.closest('.gcc-full').hidden=isPreorder;}
  refreshSummary();
 }
 function setLanguage(language){
  root.lang=language;root.dir=language==='ar'?'rtl':'ltr';root.dataset.language=language;
  document.querySelectorAll('[data-copy]').forEach(el=>el.hidden=el.dataset.copy!==language);
  document.querySelectorAll('option[data-label-ar]').forEach(el=>el.textContent=el.getAttribute('data-label-'+language));
  document.querySelectorAll('[data-placeholder-ar]').forEach(el=>el.placeholder=el.getAttribute('data-placeholder-'+language));
  toggle.textContent=language==='ar'?'English':'العربية';
  toggle.setAttribute('aria-label',language==='ar'?'Switch to English':'التبديل إلى العربية');
  const languageInput=form.querySelector('[data-language-input]');
  if(languageInput)languageInput.value=language==='ar'?'Arabic':'English';
  try{sessionStorage.setItem('ywc_gcc_interest_language',language);}catch(_){}
  refreshSummary();
 }
 function checkoutUrl(value){
  if(!valid(value)||!countries[countryInput?.value]||panel?.dataset.enabled!=='true')return null;
  const code=panel.dataset.discount||'';
  if(!/^[A-Z0-9]{3,32}$/.test(code))return null;
  const url=new URL('/cart/'+value.variant+':'+value.quantity,window.location.origin);
  url.searchParams.set('discount',code);
  url.searchParams.set('checkout[shipping_address][country]',countries[countryInput.value]);
  url.searchParams.set('attributes[source]','gcc_interest_preorder');
  url.searchParams.set('attributes[Delivery timing]','Preorder — delivery date unconfirmed');
  url.searchParams.set('attributes[Refund before dispatch]','Full refund on request before dispatch');
  url.searchParams.set('attributes[Intended use]',document.getElementById('GccUse').value);
  url.searchParams.set('attributes[People served]',document.getElementById('GccPeople').value);
  return url;
 }
 function startPreorder(){
  if(intent()!=='preorder'||!panel)return;
  panel.querySelector('[data-preorder-error]').hidden=true;
  if(!form.reportValidity())return;
  if(localizeCountry())return;
  const value=selected();
  const url=checkoutUrl(value);
  if(!url){panel.querySelector('[data-preorder-error]').hidden=false;return;}
  panel.querySelector('[data-preorder-handoff]').hidden=false;
  panel.querySelector('[data-checkout-button]').disabled=true;
  window.location.assign(url.toString());
 }
 function localizeCountry(){
  const code=countries[countryInput?.value];
  const marketForm=document.getElementById('GccMarketForm');
  if(!code||code===marketCountry||!availableCountries.includes(code)||!marketForm)return false;
  const saved={intent:intent()};
  ['GccUse','GccPeople','GccCountry','GccCity','GccPack','GccQuantity'].forEach(id=>saved[id]=document.getElementById(id).value);
  try{sessionStorage.setItem('ywc_gcc_market_selection',JSON.stringify(saved));}catch(_){}
  marketForm.querySelector('[name="country_code"]').value=code;
  marketForm.querySelector('[name="return_to"]').value=window.location.pathname+window.location.search;
  marketForm.submit();
  return true;
 }
 try{
  const saved=JSON.parse(sessionStorage.getItem('ywc_gcc_market_selection')||'null');
  sessionStorage.removeItem('ywc_gcc_market_selection');
  if(saved&&countries[saved.GccCountry]===marketCountry){
   ['GccUse','GccPeople','GccCountry','GccCity','GccPack','GccQuantity'].forEach(id=>{
    const el=document.getElementById(id);
    if(!el||typeof saved[id]!=='string')return;
    if(el.tagName==='SELECT'&&!Array.from(el.options).some(o=>o.value===saved[id]))return;
    el.value=saved[id].slice(0,100);
   });
   const choice=choices.find(el=>el.dataset.orderIntent===saved.intent);
   if(choice)choice.checked=true;
  }
 }catch(_){}
 let language='ar';
 try{if(sessionStorage.getItem('ywc_gcc_interest_language')==='en')language='en';}catch(_){}
 setLanguage(language);
 toggle.addEventListener('click',()=>setLanguage(root.lang==='ar'?'en':'ar'));
 choices.forEach(el=>{el.disabled=false;el.addEventListener('change',refreshChoice);});
 [packInput,quantityInput].forEach(el=>el?.addEventListener('input',refreshSummary));
 countryInput?.addEventListener('change',localizeCountry);
 panel?.querySelector('[data-checkout-button]')?.addEventListener('click',startPreorder);
 form.addEventListener('submit',event=>{
  if(intent()==='preorder'){event.preventDefault();event.stopImmediatePropagation();startPreorder();}
 },true);
 form.addEventListener('keydown',event=>{
  if(intent()==='preorder'&&event.key==='Enter'&&event.target.matches('input,select')){
   event.preventDefault();startPreorder();
  }
 });
 window.addEventListener('pageshow',refreshChoice);
 const params=new URLSearchParams(window.location.search);
 form.querySelectorAll('[data-attribution]').forEach(el=>{
  const raw=params.get(el.dataset.attribution)||'';
  el.value=/^[A-Za-z0-9_ .|+\-]{0,160}$/.test(raw)?raw:'';
 });
 const previewLink=document.querySelector('[data-preview-step]');
 if(previewLink){
  previewLink.href='#GccInterestForm';
  previewLink.addEventListener('click',event=>{
   const choice=choices.find(el=>el.dataset.orderIntent==='preorder');
   if(!choice)return;
   event.preventDefault();choice.checked=true;refreshChoice();panel?.scrollIntoView({block:'center'});
  });
 }
 refreshChoice();
 const success=form.querySelector('[data-gcc-success]');
 if(success)success.focus({preventScroll:false});
})();
